import React, { useEffect, useState } from "react";
import styles from "../pages/FAQ.module.css";
import { Heading } from "@chakra-ui/react";
import Markdown from 'react-markdown'
import { Container } from "@chakra-ui/react"

const DocumentationMD = ({ isMobile }) => {
    const [doc, setDoc] = useState();

    useEffect(() => {
        fetch("/manual/docs.md").then((res) => {
            res.text().then((r) => {
                setDoc(r);
            })

        })
    });

    return (
        <Container>
            <Markdown components={{ h1: 'Text' }} >{doc}</Markdown>
        </Container >
    );
};

export default DocumentationMD;
